import { render, staticRenderFns } from "./CheckButton.vue?vue&type=template&id=5ca1b12c&scoped=true&"
import script from "./CheckButton.vue?vue&type=script&lang=js&"
export * from "./CheckButton.vue?vue&type=script&lang=js&"
import style0 from "./CheckButton.vue?vue&type=style&index=0&id=5ca1b12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca1b12c",
  null
  
)

export default component.exports